import ServiceWrapper from "Services/ServiceWrapper";
import AuthManager from "Common/AuthManager";
import AppSettings from "Settings/AppSettings";
import gmsConfig from "Settings/AppSettings";
import { TCreateModel, TCreateSubmodel } from "Pages/GMS/ABTesting/types/ab";
import { RecommenderLogsResponse, TMerchantSettings } from "../Types";

const GENERATE_END_POINT: string = '/ars/generate';
const RECOMMENDER_GENERATE_END_POINT: string = 'recommender/generate';
const PROMOTE_END_POINT: string = 'recommender/promote';
const DEPLOY_END_POINT: string = '/ars/deploy';
const LOG_DETAIL_END_POINT: string = '/ars/logs';
const ALL_LOGS_END_POINT = 'ars/merchant_logs';
const RECOMMENDER_END_POINT = 'recommender/model';
const APPLET_END_POINT = 'recommender/applet';

const BASE_URL = AppSettings.PROMOTION_API;
const API_END_URL = gmsConfig.GMS_BACKEND_API_URL;


export const generateRecommendations = async (type: string, userName: string, channelId: string) => {
    try {
        const response = await ServiceWrapper.doPost(
            `${BASE_URL}${GENERATE_END_POINT}/${channelId}`,
            {
                "type": type,
                "user_name": userName
            },
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (e) {
        return null;
    }
}

export const generateRecommender = async (modelIds: string[], channelId: string) => {
    try {
        const response = await ServiceWrapper.doPost(
            `${API_END_URL}${RECOMMENDER_GENERATE_END_POINT}`,
            {
                "models": modelIds,
                "channel": channelId
            },
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (e) {
        return null;
    }
}

export const getLiveModels = async (channelId: string) => {
    try {
        const response = await ServiceWrapper.doGet(
            `${API_END_URL}recommender/live_models/${channelId}`,
            null,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
}

/**
 * @deprecated Use promoteModels instead. This function handled promotion with applet mapping.
 * Kept for reference - DO NOT DELETE.
 */
export const promoteModelWithAppletMapping_deprecated = async (payload: AppletPayload) => {
    try {
        const response = await ServiceWrapper.doPost(
            `${API_END_URL}${PROMOTE_END_POINT}`,
            payload,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (e) {
        return null;
    }
}

export type PromoteModelsPayload = {
    channel: string;
    models: string[];
};

export const promoteModels = async (payload: PromoteModelsPayload) => {
    try {
        const response = await ServiceWrapper.doPost(
            `${API_END_URL}${PROMOTE_END_POINT}`,
            payload,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (e) {
        return null;
    }
}

export const deployRecommendations = async (userName: string, channelId: string) => {
    try {
        const response = await ServiceWrapper.doPost(
            `${BASE_URL}${DEPLOY_END_POINT}/${channelId}`,
            {
                "type": 'ARS Deployment',
                "user_name": userName
            },
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (e) {
        return null;
    }
}

export const getLogDetail = async (logId: string) => {
    try {
        const response = await ServiceWrapper.doGet(
            `${BASE_URL}${LOG_DETAIL_END_POINT}/${logId}`,
            null,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
}

export const getAllLogs = async (channelId: string) => {
    try {
        const response = await ServiceWrapper.doGet(
            `${BASE_URL}${ALL_LOGS_END_POINT}/${channelId}`,
            null,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
}

export const getRecommenderLogs = async (channelId: string, paginationParams: TPaginationParams) => {
    try {
        const response = await ServiceWrapper.doGet(
            `${API_END_URL}${RECOMMENDER_END_POINT}/list/${channelId}?page=${paginationParams.page}&per_page=${paginationParams.per_page}&sort_by=${paginationParams.sort_by}&sort_by_order=${paginationParams.sort_by_order}`,
            null,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return error;
    }
}

export const getCategoryTypes = async (industryId: string) => {
    try {
        const response = await ServiceWrapper.doGet(
            `${API_END_URL}categorytype/getbyindustryid/${industryId}`,
            null,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return error;
    }
}

export const getCategories = async (industryId: string) => {
    try {
        const response = await ServiceWrapper.doGet(
            `${API_END_URL}category/getbyindustryid/${industryId}`,
            null,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return error;
    }
}

export const createRecommenderModel = async (data: TCreateModel) => {
    try {
        const response = await ServiceWrapper.doPost(
            `${API_END_URL}${RECOMMENDER_END_POINT}`,
            data,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return error;
    }
}

export const cloneRecommenderModel = async (data: { model_id: string, model_name?: string }) => {
    try {
        const response = await ServiceWrapper.doPost(
            `${API_END_URL}${RECOMMENDER_END_POINT}/clone`,
            data,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return error;
    }
}

export const createRecommenderSubmodel = async (model_id: string, data: TCreateSubmodel) => {
    try {
        const response = await ServiceWrapper.doPost(
            `${API_END_URL}${RECOMMENDER_END_POINT}/${model_id}/submodel`,
            data,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return error;
    }
}

export const deleteRecommenderModel = async (modelId: string) => {
    try {
        const response = await ServiceWrapper.doDelete(
            `${API_END_URL}${RECOMMENDER_END_POINT}/${modelId}`,
            null,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return error;
    }
}
export const getAppletList = async (channelId: string) => {
    try {
        const response = await ServiceWrapper.doGet(
            `${API_END_URL}${APPLET_END_POINT}/list/${channelId}`,
            null,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return error;
    }
}

export const getDefaultModelOfApplet = async (appletId: string, channelId: string) => {
    try {
        const response = await ServiceWrapper.doGet(
            `${API_END_URL}${RECOMMENDER_END_POINT}/default/${appletId}?channelId=${channelId}`,
            null,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return error;
    }
}

export const getModelData = async (modelId: string) => {
    try {
        const response = await ServiceWrapper.doGet(
            `${API_END_URL}${RECOMMENDER_END_POINT}/${modelId}`,
            null,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return error;
    }
}


export const updateRecommenderModel = async (data: RecommenderLogsResponse) => {
    try {
        const response = await ServiceWrapper.doPut(
            `${API_END_URL}${RECOMMENDER_END_POINT}/${data?.model_id}`,
            data,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return error;
    }
}

export const getPromotedModels = async (channelId: string) => {
    try {
        const response = await ServiceWrapper.doGet(
            API_END_URL + `/ab_testing/models/${channelId}?status=promoted`,
            null,
            null,
            AuthManager.getGmsToken()
        );

        if (response.errorfound) {
            throw new Error('Failed to fetch promoted models');
        }

        return response;
    } catch (error) {
        console.error("Error fetching promoted models:", error);
        throw error;
    }
};

export const updateApplets = async (payload: UpdateAppletPayload) => {
    try {
        const response = await ServiceWrapper.doPost(
            `${API_END_URL}recommender/map_applets`,
            payload,
            null,
            AuthManager.getGmsToken()
        );

        if (response.errorfound) {
            throw new Error('Failed to update applets');
        }

        return response;
    } catch (error) {
        console.error("Error updating applets:", error);
        throw error;
    }
};

export const getMerchantSettings = async (channelId: string) => {
    try {
        const response = await ServiceWrapper.doGet(
            `${API_END_URL}recommender/settings/${channelId}`,
            null,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return error;
    }
}

export const createExternalModel = async (
    modelName: string,
    modelType: "Co-seller" | "Substitution",
    channelId: string,
    industryId: string
) => {
    try {
        const response = await ServiceWrapper.doPost(
            `${API_END_URL}${RECOMMENDER_END_POINT}/external`,
            { model_name: modelName, model_type: modelType, channel_id: channelId, industry_id: industryId },
            null,
            AuthManager.getGmsToken(),
            false
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
};

export const initiateExternalUpload = async (
    modelId: string,
    filename: string,
    fileSizeBytes: number
) => {
    try {
        const response = await ServiceWrapper.doPost(
            `${API_END_URL}${RECOMMENDER_END_POINT}/external/${modelId}/upload/initiate`,
            { filename, file_size_bytes: fileSizeBytes },
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
};

export const getUploadPartUrls = async (
    modelId: string,
    uploadUuid: string,
    startPart: number,
    endPart: number
) => {
    try {
        const response = await ServiceWrapper.doPost(
            `${API_END_URL}${RECOMMENDER_END_POINT}/external/${modelId}/upload/${uploadUuid}/parts`,
            { start_part: startPart, end_part: endPart },
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
};

export const completeExternalUpload = async (
    modelId: string,
    uploadUuid: string
) => {
    try {
        const response = await ServiceWrapper.doPost(
            `${API_END_URL}${RECOMMENDER_END_POINT}/external/${modelId}/upload/${uploadUuid}/complete`,
            {},
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
};

export const abortExternalUpload = async (
    modelId: string,
    uploadUuid: string
) => {
    try {
        const response = await ServiceWrapper.doPost(
            `${API_END_URL}${RECOMMENDER_END_POINT}/external/${modelId}/upload/${uploadUuid}/abort`,
            {},
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
};

export const updateMerchantSettings = async (channelId: string, merchantSettings: TMerchantSettings) => {
    try {
        const response = await ServiceWrapper.doPut(
            `${API_END_URL}recommender/update_settings/${channelId}`,
            merchantSettings,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return error;
    }
}